import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import { faCircleInfo, faPenToSquare } from '@fortawesome/pro-regular-svg-icons';

import * as S from './ShipmentInfoBar.styled';

const ShipmentInfoBar = ({ volumetricWeight, isQuickShipment }) => {
	const { t } = useTranslation();
	const formMethods = useFormContext();
	const { watch, setValue } = formMethods;
	const paymentMethod = watch('paymentMethod');
	const isNotLargeDesktop = useMediaQuery(Breakpoints.desktop);
	const isMobileLandscape = useMediaQuery(Breakpoints.mobileLandscape);
	const isTablet = useMediaQuery(Breakpoints.tablet);
	const InfoContainerArray = [
		{
			title: 'orderID',
			value: watch('ID'),
			divider: true
		},
		{
			title: 'origin',
			value: [t(watch('originAddress.cityName')), t(`country.${watch('originAddress.countryName')}`)]
				.filter((item) => !!item)
				.join(', '),
			divider: true
		},
		{
			title: 'destination',
			value: [t(watch('destinationAddress.cityName')), t(`country.${watch('destinationAddress.countryName')}`)]
				.filter((item) => !!item)
				.join(', '),
			divider: !!(volumetricWeight || paymentMethod)
		},
		{
			title: 'paymentMethod',
			value: paymentMethod,
			divider: !!volumetricWeight
		},
		{
			title: 'pricecalculator.infobar.volumetricWeight',
			tooltip: 'pricecalculator.infobar.volumetricWeightTooltip',
			value: volumetricWeight && `${volumetricWeight} ${t('kg')}`
		}
	];

	return (
		<S.ShippingOptionsInfoCard rounded>
			<S.ShippingInfo>
				{isNotLargeDesktop ? (
					<Swiper
						style={{
							'--swiper-navigation-color': '#var(--black)',
							'--swiper-navigation-size': '12px'
						}}
						spaceBetween={20}
						centeredSlides={false}
						slidesPerView={isMobileLandscape ? 2 : isTablet ? 3 : 4}
						navigation={true}
						modules={[Navigation]}
						className="swiperInfo">
						{InfoContainerArray.filter(
							(item) => item.value !== undefined && item.value !== null && item.value !== ''
						).map((item, index) => (
							<SwiperSlide key={index}>
								<S.InfoContainer>
									<S.TooltipContainer>
										<Typography fontWeight="500" noWrap>
											{item.title}
										</Typography>
										{item.tooltip && (
											<Tooltip placement="right" title={item.tooltip}>
												<Icon icon={faCircleInfo} color="var(--black)" />
											</Tooltip>
										)}
									</S.TooltipContainer>
									<Typography color="var(--content-2)" noWrap>
										{item?.value}
									</Typography>
								</S.InfoContainer>
							</SwiperSlide>
						))}
					</Swiper>
				) : (
					<>
						{InfoContainerArray.filter(
							(item) => item.value !== undefined && item.value !== null && item.value !== ''
						).map((item, index) => (
							<React.Fragment key={index}>
								<S.InfoContainer>
									<S.TooltipContainer>
										<Typography fontWeight="500">{item.title}</Typography>
										{item.tooltip && (
											<Tooltip placement="top" title={item.tooltip}>
												<Icon icon={faCircleInfo} color="var(--black)" />
											</Tooltip>
										)}
									</S.TooltipContainer>
									<Typography color="var(--content-2)">{item?.value}</Typography>
								</S.InfoContainer>
								{item?.divider && <S.Divider />}
							</React.Fragment>
						))}
					</>
				)}
			</S.ShippingInfo>

			{!isQuickShipment && (
				<Button
					variant="outline"
					label="edit"
					icon={faPenToSquare}
					onClick={() => {
						setValue('editMode', true);
					}}
				/>
			)}
		</S.ShippingOptionsInfoCard>
	);
};

export default ShipmentInfoBar;
